import React, { PropsWithChildren, createContext } from "react";
import { Dictionary } from "../../carlsberg-headless/types/Dictionary";

export interface DictionaryProviderAPI {
  get: (path: string, cultureKey: string) => string | undefined;
}

export interface DictionaryProviderProps {
  data: {
    dictionary: Dictionary;
  };
}

const initialContext: DictionaryProviderAPI = {
  get: () => "",
};

const get = (path: string, cultureKey: string, dictionary: Dictionary) => {
  const dictionaryItem = dictionary[path];

  if (!dictionaryItem) return;

  return (
    Object.fromEntries(
      Object.entries(dictionaryItem).map(([k, v]) => [k.toLocaleLowerCase(), v])
    )[cultureKey.toLocaleLowerCase()]?.value || ""
  );
};

const DictionaryContext = createContext<DictionaryProviderAPI>(initialContext);

const DictionaryProvider: React.FC<
  PropsWithChildren<DictionaryProviderProps>
> = ({ data, children }) => {
  const _get = (path: string, cultureKey: string) =>
    get(path, cultureKey, data.dictionary);

  return (
    <DictionaryContext.Provider
      value={{
        ...initialContext,
        ...data,
        get: _get,
      }}
    >
      {children}
    </DictionaryContext.Provider>
  );
};

export { DictionaryProvider, DictionaryContext };
